
interface CreativeDataInputProps {
  creativeUrls: string;
}

const CreativeDataInput = ({ creativeUrls }: CreativeDataInputProps) => {
  return (
    <input 
      type="hidden" 
      id="creative-data" 
      data-creatives={creativeUrls} 
    />
  );
};

export default CreativeDataInput;
